import styled from 'styled-components';

export const ToastText =styled.div`
margin-left:8px;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 17px;
letter-spacing: -0.19968px;
color: #000000;
`;

